export default __webpack_public_path__ + "static/media/Zeus-7.d7d44dc6.pdf";